var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-full"},[(_vm.mediaKitData)?_c('doughnut-chart',{staticClass:"media-mix-pie-chart flex relative",attrs:{"chart-data":_vm.mediaKitData},scopedSlots:_vm._u([{key:"tooltip",fn:function(ref){
var tooltipModel = ref.tooltipModel;
return [_c('custom-chart-tooltip',{attrs:{"tooltip-model":tooltipModel}})]}}],null,false,2517607878)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }